import React, { useState, useEffect, useRef } from 'react';
import {
    Drawer, DrawerBody, DrawerFooter, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton,
    Button, Input, FormControl, VStack, Box, Text, Avatar, Flex, useToast
} from '@chakra-ui/react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { BASE_URL } from '../../Globalapi/Globalapi';

const Assign_T = ({ isOpen, onClose, classId: propClassId }) => {
    const { classId: paramClassId } = useParams(); // Extract classId from URL
    const classId = paramClassId || propClassId; // Use URL parameter if available, otherwise fallback to prop
    const btnRef = useRef();
    const [searchTerm, setSearchTerm] = useState('');
    const [staffData, setStaffData] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState(null);
    const [error, setError] = useState('');
    const toast = useToast(); // Initialize the toast hook
    
    useEffect(() => {
        const fetchStaffData = async () => {
            const jwt = sessionStorage.getItem('jwt'); // Get JWT from session storage

            if (!jwt) {
                console.error('JWT is missing.');
                return;
            }

            try {
                const school_id = sessionStorage.getItem('school_id'); // If JWT is needed

                const response = await axios.get(`${BASE_URL}/admin/staff/staff_list.php?school_id=${school_id}`, {
                    headers: {
                        'Authorization': `Bearer ${jwt}`
                    }
                });

                if (response.data && response.data.data && Array.isArray(response.data.data)) {
                    setStaffData(response.data.data);
                } else {
                    console.error('Unexpected API response format:', response.data);
                }
            } catch (error) {
                console.error('Error fetching staff data:', error);
                setError('Error fetching staff data');
            }
        };

        fetchStaffData();
    }, []);

    const handleStaffClick = (staff) => {
        setSelectedStaff(staff);
        console.log(`Selected staff: ${staff.name}, ID: ${staff.id}`);
    };

    const handleAssignTeacher = async () => {
        if (!selectedStaff) {
            toast({
                title: "No teacher selected.",
                status: "warning",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        if (!classId) {
            console.error('Invalid classId:', classId);
            return;
        }

        const jwt = sessionStorage.getItem('jwt'); // Get JWT from session storage

        try {
            const response = await axios.put(`${BASE_URL}/admin/class/assign_teacher.php`, {
                class_details_id: classId,
                class_teacher_id: selectedStaff.id
            }, {
                headers: {
                    'Authorization': `Bearer ${jwt}`
                }
            });

            console.log('Assign Teacher API Response:', response.data);

            if (response.data.success) {
                toast({
                    title: `Successfully assigned ${selectedStaff.name} to class ${classId}.`,
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                });
                onClose();
            } else if (response.data.message === 'Teacher already assigned') { // Assuming this is the error message
                toast({
                    title: "Teacher is already assigned to another class.",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            } else {
                toast({
                    title: "Failed to assign teacher.",
                    description: response.data.message,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            }
        } catch (error) {
            console.error('Error assigning teacher:', error);
            setError('Error assigning teacher');
            toast({
                title: "Error assigning teacher.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    const filteredStaff = staffData.filter((staff) =>
        staff.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Drawer
            isOpen={isOpen}
            placement="right"
            onClose={onClose}
            finalFocusRef={btnRef}
        >
            <DrawerOverlay />
            <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader>Assign Teacher to Class</DrawerHeader>
                <DrawerBody>
                    <FormControl>
                        <Input
                            placeholder="Search staff"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </FormControl>

                    <VStack spacing={4} mt={4} align="flex-start">
                        {filteredStaff.map((staff) => (
                            <Box
                                key={staff.id}
                                p={4}
                                borderWidth={selectedStaff?.id === staff.id ? 2 : 0} // Highlight selected staff
                                borderColor={selectedStaff?.id === staff.id ? 'blue.500' : 'gray.200'} // Change color for selected staff
                                borderRadius="md"
                                cursor="pointer"
                                onClick={() => handleStaffClick(staff)}
                            >
                                <Flex align="center">
                                    <Avatar name={staff.name} src={staff.image_url} mr={4} />
                                    <Text fontSize="lg">{staff.name}</Text>
                                </Flex>
                            </Box>
                        ))}
                    </VStack>

                    {selectedStaff && ( // Display selected staff details
                        <Box mt={4} p={4} borderWidth={1} borderRadius="md">
                            <Text fontSize="md" fontWeight="bold">
                                Selected Staff:
                            </Text>
                            <Flex align="center" mt={2}>
                                <Avatar name={selectedStaff.name} src={selectedStaff.image_url} mr={4} />
                                <Box>
                                    <Text fontSize="lg">{selectedStaff.name}</Text>
                                </Box>
                            </Flex>
                        </Box>
                    )}
                </DrawerBody>

                <DrawerFooter>
                    <Button variant="outline" mr={3} onClick={onClose}>
                        Cancel
                    </Button>
                    <Button colorScheme="blue" onClick={handleAssignTeacher}>
                        Assign Teacher
                    </Button>
                </DrawerFooter>
            </DrawerContent>
        </Drawer>
    );
};

export default Assign_T;
